import * as React from 'react';
import SingleBreak from 'common/components/common/breaks/SingleBreak';

export class BreakShift extends React.PureComponent {
    render() {
        const { breakShift, ...others } = this.props;
        const {
            duration,
            location,
            startShiftInstant,
            endShiftInstant
        } = breakShift;
        const startTime = startShiftInstant.getDayAdjustedTimeMoment();
        const endTime = endShiftInstant.getDayAdjustedTimeMoment();
        return (
            <SingleBreak
                {...others}
                transactionDuration={duration}
                startLocationAddress={
                    location ? location.getAddressString() : ''
                }
                startShiftInstant={startShiftInstant}
                endShiftInstant={endShiftInstant}
                startTime={startTime}
                endTime={endTime}
                breakShift={breakShift}
            />
        );
    }
}

export default BreakShift;
